import { render, staticRenderFns } from "./payWay.vue?vue&type=template&id=33d8610e&scoped=true&"
import script from "./payWay.vue?vue&type=script&lang=js&"
export * from "./payWay.vue?vue&type=script&lang=js&"
import style0 from "./payWay.vue?vue&type=style&index=0&id=33d8610e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d8610e",
  null
  
)

export default component.exports